import { h } from "preact";
import { useState } from "preact/hooks";
import "../APITab.css";

const ApiBaseUrl = () => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText("https://services.kz-ala-1.verigram.kz");
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="api-base-url-container">
            <span className="api-base-url-label">Your API base URL:</span>
            <code className="api-base-url-code">
                https://services.kz-ala-1.verigram.kz
            </code>
            <button
                onClick={handleCopy}
                className={`api-base-url-copy-button ${copied ? "copied" : ""}`}
                title={copied ? "Copied!" : "Copy to clipboard"}
            >
                {copied ? (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 6L9 17l-5-5" />
                    </svg>
                ) : (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                        <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
                    </svg>
                )}
                {copied && (
                    <span className="copy-tooltip">Copied!</span>
                )}
            </button>
        </div>
    );
};

export default ApiBaseUrl;